import React from 'react';
import cn from 'classnames';
import { useState } from 'react';
import { motion } from 'framer-motion';

const Accordion = ({ title, className, copy, children, onClick, ...rest }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(!isOpen);
  return (
    <div className={cn('accordion', isOpen && 'isOpen')}>
      <div className="accordion-item">
        <button
          className="accordion-button"
          onClick={e => {
            e.preventDefault();
            open(true);
          }}
        >
          <div>
            <div className="accordion-subtitle">{title}</div>
            <p className="accordion-copy">{copy}</p>
          </div>
          <div className="accordion-arrow">
            {!isOpen ? <button onClick={onClick}>ver más</button> : <button>ver menos</button>}
            <motion.svg
              initial={{ rotate: 180 }}
              animate={{ rotate: isOpen ? 0 : 180 }}
              transition={{ duration: 0.35 }}
              width={9}
              height={5}
              fill="none"
            >
              <path
                d="M1.50781 4.625C1.44531 4.67969 1.375 4.70703 1.29688 4.70703C1.21094 4.70703 1.13672 4.67578 1.07422 4.61328C1.01953 4.55859 0.996094 4.48828 1.00391 4.40234C1.00391 4.32422 1.03125 4.25781 1.08594 4.20313L4.64844 0.640625C4.74219 0.546875 4.85937 0.5 5 0.5C5.13281 0.5 5.25 0.546875 5.35156 0.640625L8.91406 4.20312C8.96875 4.26562 8.99609 4.33594 8.99609 4.41406C8.99609 4.49219 8.96875 4.5625 8.91406 4.625C8.85156 4.67969 8.78125 4.70703 8.70312 4.70703C8.61719 4.70703 8.54688 4.67969 8.49219 4.625L5 1.13281L1.50781 4.625Z"
                fill="#007AB7"
              />
            </motion.svg>
          </div>
        </button>

        <motion.div
          className="accordion-panel"
          initial={{ height: 0 }}
          animate={{ height: isOpen ? '100%' : 0 }}
          transition={{ duration: 0.35 }}
        >
          {children}
        </motion.div>
      </div>

      <style jsx global>
        {`
          .accordion {
            border: 0;
            box-shadow: none;
            background-color: transparent;
            border-bottom: 1px solid #efe9e5;
            overflow: visible;
          }

          .accordion-item {
            background-color: transparent;
            border: 0;
            box-shadow: none;
          }

          .accordion-button {
            appearance: none;
            background-color: transparent;
            border: 0;
            box-shadow: none;
            text-align: left;
            appearance: none;
            padding: 16px 0;
            display: flex;
            justify-content: space-beteen;
            flex-wrap: nowrap;
            position: relative;
            cursor: pointer;
            width: 100%;
          }

          .accordion-arrow {
            flex-shrink: 0;
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            position: absolute;
            right: 0;
            top: calc(50% - 12px);
          }

          .accordion-arrow button {
            margin: 0;
            font-family: 'ItauText', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            color: #007ab7;
            margin-right: 6px;
            background-color: transparent;
            border: 0;
            cursor: pointer;
          }

          .accordion-subtitle {
            font-weight: bold;
            font-size: 18px;
            line-height: 27px;
            color: #56504c;
            margin-bottom: 0;
          }

          .accordion-copy {
            font-family: 'ItauText', sans-serif;
            font-weight: bold;
            font-size: 12px;
            line-height: 20px;
            color: #56504c;
            margin-bottom: 0;
            font-weight: 400;
            margin-top: 0;
            max-width: calc(100% - 112px);
          }
          .accordion-panel {
            overflow: hidden;
            width: calc(100% + 20px);
            margin-left: -10px;
            padding: 0 10px;
          }

          .accordion-item[data-state='open'] .accordion-panel {
          }
        `}
      </style>
    </div>
  );
};

export default Accordion;
